import {  useState } from "react";
import { ProjectModel } from "../../base/models/projectModel";
import BodyView from "./components/bodyView";
import LeftMenu from "./components/leftMenu";
import LoginFormView from "./components/loginFormView";
import SettingFileView from "./components/settingFileView";

const AdminView = () => {
  const [isAuthenticated, setAuthentication] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedProject, setSelectedProject] = useState<ProjectModel>();

  // useEffect(() => {
  //   const checkToken = () => {
  //     const token = localStorage.getItem("token");
  //     if (token) {
  //       setAuthentication(true);
  //     }
  //   };

  //   checkToken();
  // }, []);

  return (
    <SettingFileView setAuthentication={setAuthentication}>
      {isAuthenticated ? (
        <div className="flex flex-col md:flex-row gap-8">
          <div>
            <LeftMenu
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              selectedProject={selectedProject}
            />
          </div>
          <BodyView
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
          />
        </div>
      ) : (
        <LoginFormView setAuthentication={setAuthentication} />
      )}
    </SettingFileView>
  );
};

export default AdminView;
